import { v5 as uuidv5 } from 'uuid'

const SIGNUP_MOTIVATIONS_NAMESPACE = '777ea880-450e-11f0-abff-325096b39f47'

export const SIGNUP_MOTIVATIONS = [
  {
    title: 'Try Exciting New Recipes',
    event: 'new_recipes',
  },
  {
    title: 'Pack in More Veg',
    event: 'more_veg',
  },
  {
    title: 'Find Meals for Your Family',
    event: 'meals_for_your_family',
  },
  {
    title: 'Cook Lower Calorie Meals',
    event: 'lower_calorie_meals',
  },
  {
    title: 'Save Time Cooking',
    event: 'save_time',
  },
] as const

export const signupMotivationsData = SIGNUP_MOTIVATIONS.map((motivation) => ({
  id: uuidv5(motivation.title, SIGNUP_MOTIVATIONS_NAMESPACE),
  ...motivation,
}))

export const signupMotivationUUIDs = signupMotivationsData.map((motivation) => motivation.id)

export const getEventNamesFromUUID = (uuids: string[]) =>
  signupMotivationsData.filter((item) => uuids.includes(item.id)).map((item) => item.event)
